import { UserRolesConditionEnum, UserRolesEnum } from '@ui-core/enums/user-roles.enum'
import { featureRoles } from '@ui-core/utils/role-resolver'
import { MenuItem } from 'primeng/api'

const menuItems: MenuItem[] = [
    {
        label: 'Dashboard',
        routerLink: '/dashboard',
        icon: 'pi pi-home',
        state: {
            menuActive: 'kermit-chats',
            expandMenu: false,
            permission: {
                roles: [...featureRoles('Chat_History', 'Health_Dashboard'), UserRolesEnum.Ballance_Deep_Eval],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
    {
        label: 'Admin',
        icon: 'pi pi-user-plus',
        routerLink: '/admin',
        state: {
            menuActive: 'admin',
            expandMenu: false,
            permission: {
                roles: [UserRolesEnum.Ballance_Admin],
                condition: UserRolesConditionEnum.Any,
            },
        },
    },
]

export const UI_MENU: MenuItem[] = [...menuItems]
